import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, BrainCircuit, Users } from 'lucide-react';
export function Slide06Ecosystem() {
  const products = [{
    name: 'Finns i Sjön',
    desc: 'Digital, gamified sampling',
    icon: Smartphone,
    color: '#4fd1c5'
  }, {
    name: 'SponsrAI',
    desc: 'AI matching brands & organizers',
    icon: BrainCircuit,
    color: '#ffd700'
  }, {
    name: 'Co‑Brand Sampling™',
    desc: 'Physical sampling with shared cost',
    icon: Users,
    color: '#f472b6'
  }];
  return <div className="flex flex-col h-full justify-center max-w-7xl mx-auto w-full" data-id="element-80">
      <motion.h2 className="text-5xl font-bold text-white mb-20 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-81">
        Sampler Solutions: <span className="text-[#4fd1c5]" data-id="element-82">An Ecosystem</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-83">
        {products.map((product, i) => <motion.div key={i} initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.3,
        type: 'spring',
        stiffness: 80
      }} className="relative group" data-id="element-84">
            <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-3xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-85" />
            <div className="relative p-10 flex flex-col items-center text-center h-full border border-white/10 rounded-3xl bg-white/5 backdrop-blur-sm" data-id="element-86">
              <motion.div className="w-24 h-24 rounded-full flex items-center justify-center mb-8" style={{
            backgroundColor: `${product.color}20`
          }} animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            delay: i
          }} data-id="element-87">
                <product.icon className="w-12 h-12" style={{
              color: product.color
            }} data-id="element-88" />
              </motion.div>

              <h3 className="text-3xl font-bold text-white mb-4" data-id="element-89">
                {product.name}
              </h3>
              <p className="text-xl text-white/70" data-id="element-90">{product.desc}</p>
            </div>

            {/* Connecting lines */}
            {i < 2 && <motion.div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-white/20" initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          delay: 1 + i * 0.3
        }} data-id="element-91" />}
          </motion.div>)}
      </div>
    </div>;
}